var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg6Mobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 929,
    viewBox: "0 0 360 929",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_94517)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.468,
    cy: 301.04,
    rx: 205.468,
    ry: 301.04,
    transform: "matrix(0.633824 0.773477 -0.618483 0.785798 421.375 400.664)",
    fill: "url(#paint0_linear_447_94517)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_447_94517)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.468,
    cy: 301.04,
    rx: 205.468,
    ry: 301.04,
    transform: "matrix(0.633824 0.773477 -0.618483 0.785798 505.039 170)",
    fill: "url(#paint1_linear_447_94517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_94517",
    x: -61.8125,
    y: 311.131,
    width: 854.461,
    height: 970.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_447_94517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_447_94517",
    x: -58.1484,
    y: 0.466797,
    width: 1014.46,
    height: 1130.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 140,
    result: "effect1_foregroundBlur_447_94517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_94517",
    x1: 205.468,
    y1: 0,
    x2: 205.468,
    y2: 602.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_447_94517",
    x1: 205.468,
    y1: 0,
    x2: 205.468,
    y2: 602.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg6Mobile);
export default __webpack_public_path__ + "static/media/bg6-mobile.67eaec9df48f95f8faad0e4d79192499.svg";
export { ForwardRef as ReactComponent };